// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d827d011","545":"5904a0f8"}[chunkId] + ".chunk.js";
};